import { render, staticRenderFns } from "./player2.vue?vue&type=template&id=0adcee78&scoped=true"
import script from "./player2.vue?vue&type=script&lang=js"
export * from "./player2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcee78",
  null
  
)

export default component.exports